import Vue from "vue";
import moment from "moment";

Vue.filter('partName', function (name) {
    return name.split(' ')[0];
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

Vue.filter('dateGetMes', function (value) {
    if (value) {
        return moment().format('DD/MM/YYYY')
    }
});

Vue.filter('formatDateHora', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm')
    }
});

Vue.filter('formatDateHoraUtc', function (value) {
    if (value) {
        return moment.utc(String(value)).format('DD/MM/YYYY HH:mm');
    }
});

Vue.filter('formatDateCompetencia', function (value) {
    if (value) {
        return moment(String(value)).format('MM/YYYY');
    }
});

Vue.filter('formatCompetencia', function (value) {
    if (value) {
        const d = String(value)
        const ano = d.substr(0, 4)
        const mes = d.substr(4, 2)
        return `${mes}/${ano}`
    }
});

Vue.filter('removeHour', function (value) {
    if (value) {
        return String(value).substr(0, 8)
    }
});

Vue.filter('formatDataSimples', function (value) {
    if (value) {
        const d = moment(String(value))
        d.format('YYYY/MM/DD')
        return d.format('DD/MM/YYYY')
    }
});

Vue.filter('formatDataHoraSimples', function (value) {
    if (value) {
        const d = String(value)
        const ano = d.substr(0, 4)
        const mes = d.substr(4, 2)
        const dia = d.substr(6, 2)
        const hora = d.substr(8, 2)
        const minuto = d.substr(10, 2)
        return `${dia}/${mes}/${ano} ${hora}:${minuto}`
    }
});

Vue.filter('naoInformado', function (dado) {
    const res = "Não informado";
    if (!dado || dado === '0') {
        return res;
    }
    return dado;
});

Vue.filter('s_NtoText', function (value) {
    return (value === 'S') ? 'Sim' : 'Não';
});

Vue.filter('formatNumeroBr', function (valor) {
    if (!valor) {
        valor = 0.00
    }
    const _valor = Number(valor);
    return _valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
});

Vue.filter('formatPorcentagemBr', function (valor) {
    const numero = Number(valor || 0);
    return numero.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + '%';
});

Vue.filter('primeiraLetra', function (nome) {
    const _nome = nome.toString();
    const __nome = _nome.trim()
    return __nome.charAt(0).toUpperCase();
});

Vue.filter('cpfCnpj', function (value) {
    if (!value) return '';
    const digits = value.toString().replace(/\D/g, '');
    if (digits.length <= 11) {
        return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    } else {
        return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
});

Vue.filter('monthNames', function (mes) {
    const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];
    mes = Number(mes);
    return monthNames[mes - 1];
});

